import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import imgFallback from 'src/utils/image';
import { useTheme } from 'src/hooks';

function Slide({ isActive, project, isMobile }) {
  const {
    navigation,
    global: { readMore },
  } = useTheme();

  return (
    <Container fluid className={['primary-carousel-item px-0', isActive ? 'active' : null].join(' ').trim()} id={project.id}>
      <Row noGutters>
        <Col xs={12} lg={5} xl={6} className="py-3">
          <div className="grow-in">
            <GatsbyImage alt={project.image?.alt ?? ''} image={project.image?.image?.asset?.gatsbyImageData ?? imgFallback} />
          </div>
        </Col>
        <Col xs={12} lg={7} xl={5} className="px-lg-3 py-lg-3 ml-xl-8 d-flex justify-content-start align-items-center px-2">
          <div className="fade-in">
            <div className="text-gray-750 font-weight-bold mb-lg-4 mb-2">
              {project.services.map((service, index) => (
                <span key={index} className="badge badge-primary badge-pill mb-2 mr-2">
                  {service}
                </span>
              ))}
            </div>
            <h3 className="mb-3 text-black">{project.title}</h3>
            {}
            {!isMobile && (
              <div dangerouslySetInnerHTML={{ __html: project.description }} className="mb-6" style={{ color: 'rgba(0, 0, 0, 0.56)' }} />
            )}
            {project.link && (
              <Link to={`/${navigation.projects.path}/${project.link}`} className="btn-link-primary" tabIndex={isActive ? 0 : -1}>
                {readMore}
              </Link>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

function SliderDot({ label, isActive, onClick }) {
  return (
    <button
      type="button"
      tabIndex="0"
      onClick={onClick}
      onFocus={onClick}
      onMouseOver={onClick}
      className={['primary-carousel-indicator', isActive ? 'active' : null].join(' ').trim()}
      aria-label={`Tab 0${label}`}
    >
      {`0${label}`}
    </button>
  );
}

export const ProjectsCarousel = ({ header, projects }) => {
  const [active, setActive] = useState(0);
  const handleClick = (e) => setActive(e);

  if (projects.length === 0) {
    return null;
  }

  return (
    <Container fluid className="primary-carousel position-relative px-0 py-6">
      <Row noGutters className="d-none d-lg-flex primary-carouse-desktop-only">
        <Col xs={12} className="mb-4">
          <PortableHeader content={header} />
        </Col>
        <Col xs={12} md={10} xl={10}>
          {projects.map((project, i) => (
            <Slide
              key={project.id}
              isActive={i === active}
              project={{
                id: project.id,
                link: project.slug?.current,
                image: project.previewImageDesktop,
                title: project.title,
                description: project.description,
                services: project.services,
              }}
            />
          ))}
        </Col>
        <Col xs={12} md={2} xl={2} className="py-xl-3 d-flex justify-content-end justify-content-xl-center align-items-center">
          <Row noGutters className="primary-carousel-indicators flex-column justify-content-center">
            {projects.map((project, i) => (
              <Col xs={12} key={project.id}>
                <SliderDot id={project.id} label={i + 1} onClick={() => handleClick(i)} isActive={i === active} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {}
      <Row className="scroll-snap-type-x-mandatory scrollbar-primary pb-lg-0 d-lg-none primary-carouse-mobile-only mx-0 flex-nowrap overflow-auto pb-6">
        {projects.map((project) => (
          <Col key={project.id} xs={10} sm={8} className="scroll-snap-align-start">
            <Slide
              isActive
              isMobile
              project={{
                id: project.id,
                link: project.slug?.current,
                image: project.previewImageMobile,
                title: project.title,
                description: project.description,
                services: project.services,
              }}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};
